import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { MODELS_COMPARISON } from './routes-names'

export default (): RouteRecordRaw[] => {
  const country = useMarketplace().market.countryCode

  const { FF_NEW_COMPARE_PAGE_ENABLED_COUNTRY_CODES } =
    useRuntimeConfig().public
  const isNewComparisonPageActive =
    FF_NEW_COMPARE_PAGE_ENABLED_COUNTRY_CODES.includes(country)

  return [
    {
      path: '/:locale/compare',
      component: () =>
        import(
          '@backmarket/nuxt-layer-base/components/RouteRecordWithChildrenOnly/RouteRecordWithChildrenOnly.vue'
        ),
      meta: {
        cache: 'public, max-age=300',
      },
      children: [
        {
          name: MODELS_COMPARISON.HOME,
          path: 'home',
          component: () =>
            import(
              '~/scopes/models-comparison/pages/ModelsComparisonHome/ModelsComparisonHome.vue'
            ),
          meta: {
            owners: ['bot-squad-content-front'],
          },
        },
        {
          name: MODELS_COMPARISON.CATEGORY,
          path: ':category',
          component: () =>
            import(
              '~/scopes/models-comparison/pages/ModelsComparisonSearch/ModelsComparisonSearch.vue'
            ),
          meta: {
            owners: ['bot-squad-content-front'],
          },
        },
        {
          name: MODELS_COMPARISON.COMPARISON_RESULTS,
          path: ':productA/:productB',
          component: () =>
            isNewComparisonPageActive
              ? import(
                  '~/scopes/models-comparison/pages/ModelsComparisonResultsV2/ModelsComparisonResultsV2.vue'
                )
              : import(
                  '~/scopes/models-comparison/pages/ModelsComparisonResults/ModelsComparisonResults.vue'
                ),

          meta: {
            owners: ['bot-squad-content-front'],
          },
        },
      ],
    },
  ]
}
